module.exports = __webpack_public_path__ + "static/img/close_hammer_mob.jpg";